export enum ConnectionsTableColumnKeys {
  FirstName = 'first_name',
  LastName = 'last_name',
  Headline = 'headline',
  Email = 'email',
  Phone = 'phone',
  User = 'user',
  Tags = 'tags',
  Response = 'response',
  Conversation = 'conversation',
  Positions = 'positions',
  Companies = 'companies',
  Imported = 'imported',
  ImportedDate = 'imported_date',
  Location = 'location',
  LinkedinUrl = 'linkedin_url',
  TwitterUrl = 'twitter_url',
  FollowedOnTwitter = 'followed_on_twitter',
  Websites = 'websites',
  Ims = 'ims',
  Birthday = 'birthday',
  Campaigns = 'campaigns',
  Incomplete = 'incomplete',
  ResponseDate = 'response_date',
  ClickedLinks = 'clicked_links',
}
